import { render } from "./PayUnlockButton.vue?vue&type=template&id=84ef1b02"
import script from "./PayUnlockButton.vue?vue&type=script&lang=js"
export * from "./PayUnlockButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__